import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../../api";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
// import "../../../css/EnterpriseDetails.css";
import "../../../css/DocumentHistoryResponsive.css";
import filterIcon from "../../../assets/Images/Filter.png";
import changeStatusIcon from "../../../assets/icons/changeStatusIcon.png";
import deleteIcon from "../../../assets/Images/DeleteIcon.png";
import trainDoc from "../../../assets/icons/TrainDoc.png";
import trainText from "../../../assets/icons/TrainText.png";
import trainUrls from "../../../assets/icons/TrainUrl.png";
import trainVideo from "../../../assets/icons/TrainVideo.png";
import trainQA from "../../../assets/icons/TrainQA.png";
import { getFilteredDocs } from "../../../utils/approvedContentTabs";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../../../utils/toastMessages";
import { formatFileType } from "../../../utils/FileType";
import viewIcon from "../../../assets/Images/View.png";
import downloadIcon from "../../../assets/Images/Download.png";
import folderIcon from "../../../assets/Images/folder.png";
import pluseIcon from "../../../assets/Images/PlusIcon.png";

const UploadedDocsFiles = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("desc");
  const [dayFilter, setDayFilter] = useState("");
  const [allApprovedDocs, setAllApprovedDocs] = useState([]);
  const [attachedFiles, setAttachedFiles] = useState([]);

  const fileInputRef = useRef(null);

  const [stats, setStats] = useState({
    user_files_active_count: 0,
    user_files_inactive_count: 0,
    uploaded_files_active_count: 0,
    uploaded_files_inactive_count: 0,
  });

  const [isLoading, setIsLoading] = useState(false);

  // ✅ Fetch stats
  const fetchStats = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("access_token");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/files/stats`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      // console.log("📊 Stats API Response:", data);

      if (response.ok) {
        setStats(data.data || {});
      } else {
        // showErrorToast(data.message || "Failed to load document stats");
      }
    } catch (error) {
      console.error("❌ Error fetching stats:", error);
      showErrorToast("Something went wrong while fetching stats");
    } finally {
      setIsLoading(false);
    }
  };

  // Open file chooser
  const handleBoxClick = (item) => {
    if (item.isAddNew && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Corrected file upload function for multiple files
  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    // Mark files as uploading
    const newFiles = files.map((file) => ({ file, status: "uploading" }));
    setAttachedFiles((prev) => [...prev, ...newFiles]);

    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    try {
      const formData = new FormData();

      // Append all files to formData
      files.forEach((file) => formData.append("files", file));

      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/files/upload-multiple`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Update status for each uploaded file
      const uploadedFileNames = res.data.files.map((f) => f.user_files_name);
      setAttachedFiles((prev) =>
        prev.map((f) =>
          uploadedFileNames.includes(f.file.name) ? { ...f, status: "done" } : f
        )
      );

      showSuccessToast("Files uploaded successfully");
      navigate("/user/mydrive-save");
    } catch (error) {
      console.error("Upload failed:", error);
      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        "Server failed, please try again later.";

      // Mark all failed files as error
      setAttachedFiles((prev) =>
        prev.map((f) =>
          files.some((file) => file.name === f.file.name)
            ? { ...f, status: "error" }
            : f
        )
      );

      showErrorToast(`File upload failed: ${errorMsg}`);
    }

    // Reset file input
    e.target.value = "";
  };

  const statsData = [
    {
      label: "New",
      icon: pluseIcon,
      isAddNew: true,
    },
    {
      label: "Uploaded Documents",
      count: getFilteredDocs(allApprovedDocs, "document").length,
      icon: folderIcon,
      // count: stats.uploaded_files_active_count,
    },
    {
      label: "Saved Documents",
      icon: folderIcon,
      count: stats.user_files_active_count,
    },
    {
      label: "Deleted Documents",
      icon: folderIcon,
      count: stats.uploaded_files_inactive_count || 0,
    },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname;

  const tabs = [
    // { name: "Recently", path: "/user/mydrive-recent" },
    { name: "Uploaded", path: "/user/mydrive-docs" },
    { name: "Saved", path: "/user/mydrive-save" },
    { name: "Deleted", path: "/user/mydrive-delete" },
    // { name: "Q&A", path: "/user/qahistory" },
  ];

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const fetchGlobalUserDocs = async () => {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_API_URL}/uploaded-files/global-user-docs`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setAllApprovedDocs(res.data);
      console.log(res.data);
    } catch (error) {
      console.error("❌ Error fetching approved docs:", error);
      showErrorToast(TOAST_MESSAGES.DOCUMENT_HISTORY.FETCH_FAILED);
    }
  };

  useEffect(() => {
    fetchGlobalUserDocs();
    fetchStats();
  }, []);

  const handleDownload = async (pythonFileUUID) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/uploaded-files/download?python_file_uuid=${pythonFileUUID}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const errText = await response.text();
        throw new Error(`Failed: ${errText}`);
      }

      const blob = await response.blob();

      // ✅ Get filename from Content-Disposition header
      let filename = "downloaded_file";
      const contentDisposition = response.headers.get("Content-Disposition");
      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i
        );
        if (match && match[1]) filename = decodeURIComponent(match[1]);
      }

      // ✅ Trigger download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      console.log(`✅ File downloaded: ${filename}`);
    } catch (error) {
      console.error("❌ Download failed:", error);
      showErrorToast("Failed to download file.");
    }
  };

  const changeMode = async (fileId, newMode) => {
    try {
      if (!fileId || !newMode) {
        console.error("❌ File ID or mode missing");
        return;
      }

      const response = await api.patch(
        `${process.env.REACT_APP_API_URL}/uploaded-files/docs/change-mode/${fileId}`, // <-- backend route
        { new_mode: newMode }
      );

      if (response.data) {
        // console.log("Mode updated:", response.data);
        showSuccessToast("Mode Changed Successfully.");
        fetchGlobalUserDocs();
        return response.data;
      }
    } catch (error) {
      console.error(
        "❌ Failed to change upload mode:",
        error.response?.data || error.message
      );
    }
  };

  // Delete function
  const handleDeleteDocument = async (fileId) => {
    // if (!window.confirm("Are you sure you want to delete this document?")) return;

    try {
      await api.delete(
        `${process.env.REACT_APP_API_URL}/uploaded-files/docs/${fileId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      showSuccessToast("Document deleted successfully");
      // Refresh data after delete
      fetchGlobalUserDocs();
    } catch (error) {
      console.error("❌ Error deleting document:", error);
      showErrorToast("Failed to delete document");
    }
  };

  const documentFiles = getFilteredDocs(allApprovedDocs, "document");

  const filteredFiles = documentFiles
    .filter((file) =>
      file.name?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter((file) => {
      if (!dayFilter) return true;
      const updatedDate = new Date(file.updatedAt);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (dayFilter === "Today") return updatedDate >= today;
      if (dayFilter === "Yesterday") {
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return updatedDate >= yesterday && updatedDate < today;
      }
      return true;
    })
    .sort((a, b) => {
      const dateA = new Date(a.updatedAt);
      const dateB = new Date(b.updatedAt);
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });

  const totalEntries = filteredFiles.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filteredFiles.slice(indexOfFirst, indexOfLast);
  const showingFrom = totalEntries === 0 ? 0 : indexOfFirst + 1;
  const showingTo = Math.min(indexOfLast, totalEntries);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const handleEntriesChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageClick = (pageNum) => {
    if (pageNum < 1 || pageNum > totalPages) return;
    setCurrentPage(pageNum);
  };

  const handleReset = () => {
    setSortOrder("desc");
    setDayFilter("");
    setSearchTerm("");
    setCurrentPage(1);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  return (
    <div className="mx-2 pt-1 h-100">
      <div className="d-flex flex-wrap gap-3 mb-0 justify-content-evenly align-items-stretch">
        {/* Hidden file input */}
        <input
          type="file"
          ref={fileInputRef}
          multiple
          accept=".pdf,.doc,.docx,.txt,.csv" // only allow document types
          style={{ display: "none" }}
          onChange={handleFileChange}
        />

        {statsData.map((item, index) => (
          <div
            key={index}
            className={`dashboard-box p-3 rounded shadow-sm d-flex flex-column  ${
              item.isAddNew ? "AddNew" : ""
            }`}
            style={{
              cursor: item.isAddNew ? "pointer" : "default",
              transition: "0.2s ease",
              width: "230px",
              minHeight: "120px",
            }}
            onClick={() => handleBoxClick(item)}
          >
            {/* Top Section */}
            <div
              style={{
                flexDirection: item.isAddNew ? "column" : "row",
                gap: item.isAddNew ? "19px" : "8px",
              }}
              className={`d-flex align-items-${
                item.isAddNew ? "start" : "center"
              } ${item.isAddNew ? "" : ""}`}
            >
              {item.icon && (
                <img
                  className="icon-image"
                  src={item.icon}
                  alt={item.label}
                  style={{ width: "18px", height: "18px" }}
                />
              )}
              <h6 className="mb-0">{item.label}</h6>
            </div>

            {/* Bottom Section (count for non-AddNew) */}
            {!item.isAddNew ? (
              <div
                className="d-flex  w-100 mt-2 refresh-prompts"
                style={{ fontWeight: "600", fontSize: "16px" }}
              >
                {isLoading ? "0" : item.count ?? 0}
              </div>
            ) : (
              <div className="box-summary">
                <span className="invisible">placeholder</span>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="d-flex refresh-prompts justify-content-between align-items-center mb-2 mt-1 ">
        <span className="fw-bold" style={{ fontSize: "20px" }}>
          Uploaded Documents
        </span>
      </div>

      {/* <div className="mb-3 mt-3 tabs-wrapper">
        <div className="d-flex p-2 rounded border tab-container">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button ${
                currentTab === tab.path ? "active" : ""
              }`}
              onClick={() => navigate(tab.path)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div> */}
      <div className="mt-3 tabs-wrapper ">
        <div className="tab-container">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button ${
                currentTab === tab.path ? "active" : " "
              }`}
              onClick={() => navigate(tab.path)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      <div
        style={{ borderLeft: "1px solid var(--dark-color) " }}
        className="d-flex px-2 py-1 justify-content-between align-items-center "
      >
        <div className="d-flex align-items-center">
          <select
            className="form-select w-auto"
            value={entriesPerPage}
            onChange={handleEntriesChange}
          >
            {[50, 100, 500].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <label className="ms-2 mt-2">Entries per page</label>
        </div>

        {/* Search input */}
        <div className="search">
          <div
            className="input-group custom-search-group"
            style={{ width: "320px" }}
          >
            <span className="input-group-text">
              <i className="bi bi-search"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>
      </div>

      {totalEntries === 0 ? (
        <div className="text-center my-5">
          <p className="refresh-prompts ak-text-md profile-i">
            {/* There are no document(s) in this section. */}
            No documents have been trained yet.
          </p>
        </div>
      ) : (
        <div
          className="not-disable"
          style={{ borderLeft: "1px solid var(--dark-color) " }}
        >
          <div className="table-responsive">
            <table className="table DocHistory-table table-sm w-100">
              <thead className="text-left">
                <tr>
                  <th>Document Name</th>
                  <th>Document Type</th>
                  <th>Document Size</th>
                  <th>Privacy Mode</th>
                  <th>Document Mode</th>
                  <th>Last Updated</th>
                  <th>Document Status</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((file, index) => (
                  <tr key={file.id || index}>
                    <td
                      data-label="Document Name"
                      className="text-truncate text-left"
                      style={{ maxWidth: "150px" }}
                      title={file.name}
                    >
                      {file.name.replace(/\.[^/.]+$/, "")}
                    </td>

                    {/* <td data-label="Document Type" className="text-left">
                      {file.type}
                    </td> */}
                    <td data-label="Document Type" className="text-left">
                      {formatFileType(file.type, file.name)}
                    </td>
                    <td className="text-left" data-label="Document Size">
                      {formatFileSize(file.size)}
                    </td>

                    {/* Document Mode column */}
                    <td className="text-left" data-label="Document Mode">
                      <span
                        className="px-2 py-1 text-sm rounded-md text-[var(--primary-color)]"
                        style={{ display: "inline-block" }}
                      >
                        {file.document_mode?.toLowerCase() === "offline"
                          ? "Full Privacy"
                          : "Zero Privacy"}
                      </span>
                    </td>

                    {/* Mode column */}
                    <td className="text-left" data-label="Mode">
                      <span
                        className="px-2 py-1 text-sm rounded-md text-[var(--primary-color)]"
                        style={{ display: "inline-block" }}
                      >
                        {(file.mode || "Personal").charAt(0).toUpperCase() +
                          (file.mode || "Personal").slice(1)}
                      </span>
                    </td>
                    <td className="text-left" data-label="Updated At">
                      {new Date(file.updatedAt).toLocaleString()}
                    </td>
                    {/* <td className="text-left" data-label="Document Status">
                      <select
                        value={file.mode || "personal"} // default if mode missing
                        onChange={(e) =>
                          changeMode(file.python_file_uuid, e.target.value)
                        }
                        className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] cursor-pointer text-[var(--primary-color)] hover:border-[var(--primary-color)] bg-white"
                        style={{    
                          cursor: "pointer",
                        }}
                      >
                        <option  value="pending_global">Pending Global</option>
                        <option value="incognito">Incognito</option>
                        <option value="personal">Personal</option>
                      </select>
                    </td> */}

                    {/* <td className="text-left" data-label="Document Status">
                      <span
                        className="px-2 py-1 text-sm rounded-md text-[var(--primary-color)]"
                        style={{ display: "inline-block" }}
                      >
                        {file.mode
                          ? file.mode
                              .split("_") // split by underscore
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1)
                              ) // capitalize each word
                              .join(" ") // join with space
                          : "Personal"}
                      </span>
                    </td> */}

                    <td className="text-center" data-label="Document Status">
                      <span
                        className={`badge ${
                          file.approval_status === "approved"
                            ? "bg-success"
                            : file.approval_status === "pending"
                            ? "bg-warning"
                            : "bg-danger"
                        }`}
                      >
                        {file.approval_status.charAt(0).toUpperCase() +
                          file.approval_status.slice(1)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="table-footer bgcolor fixed-bottom-footer d-flex justify-content-between align-items-center">
            <div className="refresh-prompts">
              Showing {showingFrom} to {showingTo} of {totalEntries} entries
            </div>
            <ul className="pagination mb-0">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(1)}
                >
                  <i className="bi bi-chevron-double-left" />
                </button>
              </li>
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(currentPage - 1)}
                >
                  <i className="bi bi-chevron-left" />
                </button>
              </li>
              {pageNumbers.map((num) => (
                <li
                  key={num}
                  className={`page-item ${currentPage === num ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(num)}
                  >
                    {num}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(currentPage + 1)}
                >
                  <i className="bi bi-chevron-right" />
                </button>
              </li>
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(totalPages)}
                >
                  <i className="bi bi-chevron-double-right" />
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadedDocsFiles;
